export const patientRecordDashboardFallbacks = {
  patient: {
    id: null,
    patientId: null,
    photo: null,
    name: "Unknown Patient",
    phone: null,
    email: null,
    gender: null,
    bloodType: null,
    height: null,
    weight: null,
    diseases: null,
    latestVisit: null,
  },
  emergency: {
    name: "Not provided",
    phone: "Not provided",
    relation: null,
  },
};
